import { render, staticRenderFns } from "./OpeningStock.vue?vue&type=template&id=7072ac78&scoped=true"
import script from "./OpeningStock.vue?vue&type=script&lang=js"
export * from "./OpeningStock.vue?vue&type=script&lang=js"
import style0 from "./OpeningStock.vue?vue&type=style&index=0&id=7072ac78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7072ac78",
  null
  
)

export default component.exports